'use client';

import { c as _c } from "react/compiler-runtime";
import { SimilarProductsFilters } from '@/app/[abTest]/[locale]/(spreadshirt)/shop/design/components/SimilarProductsFilters';
import { SimilarProductsSlider } from '@/app/[abTest]/[locale]/(spreadshirt)/shop/design/components/SimilarProductsSlider';
import { DesignProductFilter, MappedDesignProductItem } from '@/app/[abTest]/[locale]/(spreadshirt)/shop/design/utility/recommendations';
import { ProductSliderSkeleton } from '@/components/ProductSlider/ProductSliderSkeleton';
type DesignSimilarProductsProps = {
  compositionId: Composition['compositionId'];
  compositionName: string;
  designProductFilters: DesignProductFilter[];
  activeFilter: DesignProductFilter | undefined;
  onActiveFilterChange: (filter: DesignProductFilter) => void;
  mappedDesignProductItems: MappedDesignProductItem[];
  isLoadingItems: boolean;
  shopId: number;
};

// Purely presentational: which tab is active (and what to fetch for it) is owned by
// SimilarProductsRecommendationsWrapper, since selecting a tab triggers that tab's data fetch.
export const SimilarProductsRecommendations = t0 => {
  const $ = _c(14);
  const {
    compositionId,
    compositionName,
    designProductFilters,
    activeFilter,
    onActiveFilterChange,
    mappedDesignProductItems,
    isLoadingItems,
    shopId
  } = t0;
  let t1;
  if ($[0] !== activeFilter || $[1] !== designProductFilters || $[2] !== onActiveFilterChange) {
    t1 = <SimilarProductsFilters designProductFilters={designProductFilters} activeFilter={activeFilter} onActiveFilterChange={onActiveFilterChange} />;
    $[0] = activeFilter;
    $[1] = designProductFilters;
    $[2] = onActiveFilterChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== activeFilter?.id || $[5] !== compositionId || $[6] !== compositionName || $[7] !== isLoadingItems || $[8] !== mappedDesignProductItems || $[9] !== shopId) {
    t2 = isLoadingItems ? <div className="mt-6"><ProductSliderSkeleton /></div> : <SimilarProductsSlider key={activeFilter?.id} compositionId={compositionId} compositionName={compositionName} mappedDesignProductItems={mappedDesignProductItems} shopId={shopId} trackingDetail={`reco this-design-on-other-products ${activeFilter?.id ?? "all"}`} />;
    $[4] = activeFilter?.id;
    $[5] = compositionId;
    $[6] = compositionName;
    $[7] = isLoadingItems;
    $[8] = mappedDesignProductItems;
    $[9] = shopId;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};